module.exports = __webpack_public_path__ + "media/images/corrientes-7a9e385c6627b74dc964b003bfc62963.svg";